import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { observer, inject } from "mobx-react";
import ErrorParser from "../../../ErrorParser";

class ErrorDetail extends Component {
  render() {
    const { stores, handler } = this.props;

    const { error } = handler;

    const parsedError = new ErrorParser(error, stores);

    let {
      exceptionMessageDetail,
      exceptionType,
      stackTraceLines
    } = parsedError;
    let stackTrace = null;

    if (stackTraceLines) {
      const items = stackTraceLines.map((l, idx) => <li key={idx}>{l}</li>);
      stackTrace = <ul>{items}</ul>;
    }

    return (
      <Modal.Body>
        <h4>{exceptionMessageDetail}</h4>
        <p>{exceptionType}</p>
        <div className="stacktrace">{stackTrace}</div>
      </Modal.Body>
    );
  }
}

export default inject("stores", "handler")(observer(ErrorDetail));



// WEBPACK FOOTER //
// ./src/Core/Components/Modals/ErrorDetail/index.js